import axios from "axios";
import { useEffect, useState } from "react";

const useSurveyAutosave = () => {
  const [recordId, setRecordId] = useState(
    localStorage.getItem("surveyRecordId") || null,
  );

  useEffect(() => {
    if (recordId) {
      localStorage.setItem("surveyRecordId", recordId);
    }
  }, [recordId]);

  const saveSurveyProgress = async (answers) => {
    const companyDetails =
      JSON.parse(localStorage.getItem("companyDetails")) || {};
    const { logo } = companyDetails;

    const email = JSON.parse(localStorage.getItem("email")) || "";
    const memberName = JSON.parse(localStorage.getItem("member_name")) || "";
    const companyName = JSON.parse(localStorage.getItem("company_name")) || "";
    const webUrl = JSON.parse(localStorage.getItem("weburl")) || "";

    // Initialize all questions with default value 0
    const totalQuestions = 78;
    const completeAnswers = {};

    for (let i = 1; i <= totalQuestions; i++) {
      const key = `q${i}`;
      completeAnswers[key] = answers[key] ?? 0;
    }

    try {
      const dataToPost = {
        ...completeAnswers,
        member_id: 0,
        company_id: 0,
      };

      const formData = new FormData();
      Object.entries(dataToPost).forEach(([key, value]) => {
        formData.append(key, value);
      });

      formData.append("company_name", companyName || "");
      formData.append("email", email || null);
      formData.append("member_name", memberName);
      formData.append("weburl", webUrl);
      formData.append("logofile", logo || null);
      if (recordId) {
        formData.append("id", recordId); // Pass recordId only 2nd page onwards
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/surveydata`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      // Store the recordId only after the first successful call
      if (!recordId) {
        localStorage.setItem("surveyRecordId", response.data?.id);
        setRecordId(response.data?.id);
      }

      return response.data;
    } catch (error) {
      console.error("Error saving survey data:", error);
      return null;
    }
  };

  return { recordId, saveSurveyProgress };
};

export default useSurveyAutosave;
